angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "RECENT_BOOKINGS": {
    "CITY_FILTER_BOOKINGS_TITLE": "Recent local guide bookings in {LOCATION}"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/translations/recent_bookings.json
// module id = 432
// module chunks = 24